import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-confirm-edit-dialog',
  templateUrl: './confirm-edit-dialog.component.html',
})
export class ConfirmEditDialogComponent {

}
